"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _r10SourceLibrary = require("r10-source-library");
var _useCurrentPageContent = _interopRequireDefault(require("../../hooks/app/useCurrentPageContent"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const DynamicRecommendationSummary = _ref => {
  let {
    testId
  } = _ref;
  const breakPoints = (0, _r10SourceLibrary.useBreakpoints)();
  const {
    recommendationSummary: RecommendationSummary
  } = (0, _useCurrentPageContent.default)();
  const flexDirection = (0, _react.useMemo)(() => breakPoints.sm ? 'column' : 'row', [breakPoints]);
  return RecommendationSummary ? /*#__PURE__*/_react.default.createElement(RecommendationSummary, {
    flexDirection: flexDirection,
    testId: testId
  }) : null;
};
var _default = DynamicRecommendationSummary;
exports.default = _default;
DynamicRecommendationSummary.propTypes = {
  testId: _propTypes.default.string
};